import { Android, IOS } from '@beef/smart-kit';
export var PLATFORM_TYPE = {
  appStore: IOS,
  googlePlay: Android,
  appGallery: Android,
  ruStore: Android
};